// src/services/fareApi.js
import api from "./api";

/**
 * Fetch all fare settings from the backend.
 */
export const fetchFareSettings = async () => {
  const response = await api.get("/admin/fare-settings");
  return response.data?.data || [];
};

/**
 * Fetch a single fare setting by type.
 */
export const fetchFareSetting = async (type) => {
  const response = await api.get(`/admin/fare-settings/${type}`);
  return response.data?.data;
};

/**
 * Update one fare setting by type.
 */
export const updateFareSetting = async (type, data) => {
  const response = await api.put(`/admin/fare-settings/${type}`, data);
  return response.data;
};

/**
 * Preview a fare calculation. Useful for the admin "Test Fare" widget.
 */
export const previewFare = async (params) => {
  const response = await api.post("/rentals/calculate-fare", params);
  return response.data;
};